import React from 'react';

import styled from 'styled-components';
import { Divider } from 'components';

import Label from './Label';

interface FormRowProps {
  label?: string;
  required?: boolean;
  divider?: boolean;
  dataCy?: string;
}

const FormRow: React.FC<FormRowProps> = ({
  children,
  label,
  required,
  divider,
  dataCy,
}) => (
    <>
      <Row data-cy={dataCy}>
        {label && <Label label={label} required={required} />}
        {children}
      </Row>
      {divider && <Divider />}
    </>
  );

export default FormRow;

const Row = styled.div`
  display: flex;
  flex-direction: column;
  margin: 16px 0px;
`;
